<template>
    <div style="width:100%;height:100%;background-color: #ededed;">
      <div class="jinriShow" v-if="content.length">
        <div class="mainTitle">{{content[0].standardData}}</div>
        <div class="subtitle">{{content[1].standardData}}</div>
        <div class="information">
          <div class="information1" v-if="content[2]"><span>账号昵称:</span><span>{{content[2].standardData}}</span></div>
          <div class="information2" v-if="content[3]"><span>发布日期:</span><span>{{content[3].standardData}}</span></div>
        </div>
        <template v-for="(item,ind) in content" >
        <div class="detailInfor" v-if="ind>3&&item.standardData" :key="ind">
            <div v-if="isPic(item.standardData)" style="text-align:center;">
              <img :src="item.standardData" alt="" style="object-fit: fill !important;">
            </div>
            <span v-else>{{item.standardData}}</span>
        </div>
        </template>
      </div>
      <img v-else
            :src="require('../../assets/image/images/newShow.png')"
            style="width:100%;height:100%;"
            alt="">
    </div>
</template>
<script>
import jinriShow from "../../components/floorBlock/jinriShowContent.vue";
export default {
  name:'jinriShow',
  components:{
    jinriShow
  },
  props:{
    imageText:Array
  },
  data(){
    return{
    }
  },
  mounted(){
  },
  computed:{
    content(){
      if(this.imageText){
       return this.imageText;
      }
    }
  },
  methods:{
    isPic (url) {
      if (url && typeof (url) == 'string' && url.indexOf('.png') > 0 || url && typeof (url) == 'string' && url.indexOf('.jpg') > 0) {
        return true;
      }
      return false;
    }
  }
}
</script>
<style scoped>
  .jinriShow{
    padding: 20px 10px 0;
    height: 100%;
    border: 1px solid #ededed;
    background-color: #fff;
    overflow:auto;
  }
  .mainTitle{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    font-size: 18px;
    font-weight: 800;
    color: #333;
    margin-bottom: 14px;
  }
  .subtitle{
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 14px;
  }
  .information{
    display: flex;
    margin-bottom: 14px;
  }
  .information div{
    margin-right: 20px;
    max-width: 200px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .information span{
    font-size: 12px;
    color: #666;
  }
  .detailInfor{
    margin-bottom: 20px;
  }
  .detailInfor img{
    width: 666px;
    height: 360px;
  }
</style>



// WEBPACK FOOTER //
// src/components/flowDetail/jinriShow.vue